import { render, staticRenderFns } from "./RevenueExpenses.vue?vue&type=template&id=675fb036&"
import script from "./RevenueExpenses.vue?vue&type=script&lang=js&"
export * from "./RevenueExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports